import { IDriverLocation, Maybe } from 'types/graphqlTypes'
import { TRACKING_METHOD_TYPE } from 'types/tracking'

const TRACKING_METHOD_NAMES: Record<
  TRACKING_METHOD_TYPE | IDriverLocation['sourceType'],
  string
> = {
  [TRACKING_METHOD_TYPE.keepTruckin]: 'KeepTruckin',
  [TRACKING_METHOD_TYPE.project44]: 'project44',
  [TRACKING_METHOD_TYPE.mobile]: 'Transfix Mobile App',
  [TRACKING_METHOD_TYPE.fmsMobile]: 'FMS Mobile',
  ios_driver_app: 'Transfix Mobile App',
  'React-Native': 'Transfix Mobile App',
  manual: 'Manual',
  one_time_location: 'One Time Location',
}

export const getTrackingMethodName = (trackingMethod: Maybe<TRACKING_METHOD_TYPE | string>) => {
  return trackingMethod ? TRACKING_METHOD_NAMES[trackingMethod as TRACKING_METHOD_TYPE] : ''
}

export const isMobileTracking = (trackingMethod: Maybe<TRACKING_METHOD_TYPE | string>) => {
  return (
    trackingMethod === TRACKING_METHOD_TYPE.mobile ||
    trackingMethod === TRACKING_METHOD_TYPE.fmsMobile
  )
}

export const getValidatedELD = (
  trackingMethod: Maybe<TRACKING_METHOD_TYPE | string>,
  keepTruckinValidated: boolean,
  project44Validated: boolean
) => {
  if (!trackingMethod) return []

  const validTruckNumber: Record<TRACKING_METHOD_TYPE, boolean> = {
    [TRACKING_METHOD_TYPE.keepTruckin]: Boolean(keepTruckinValidated),
    [TRACKING_METHOD_TYPE.project44]: Boolean(project44Validated),
    [TRACKING_METHOD_TYPE.mobile]: false,
    [TRACKING_METHOD_TYPE.fmsMobile]: false,
  }

  const isTrackingELDValid = validTruckNumber[trackingMethod as TRACKING_METHOD_TYPE]
  const isMobile = isMobileTracking(trackingMethod)
  const hasELDValidated = isMobile && (keepTruckinValidated || project44Validated)
  const validatedELD = []

  if (isTrackingELDValid || hasELDValidated) {
    if (keepTruckinValidated) {
      validatedELD.push(getTrackingMethodName(TRACKING_METHOD_TYPE.keepTruckin))
    }

    if (project44Validated) {
      validatedELD.push(getTrackingMethodName(TRACKING_METHOD_TYPE.project44))
    }
  }

  return validatedELD
}
